/** Hidden model context appended to a user message as its own text part
 *  (see ``CopilotTurnContext``). Never shown in the conversation. */
export const APP_CONTEXT_OPEN = "<app_context>";
export const APP_CONTEXT_CLOSE = "</app_context>";
export const APP_CONTEXT_PATTERN =
  /\s*<app_context>[\s\S]*?<\/app_context>\s*/g;
